import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { productsQuery } from "#modules/products/infra/products.query";
import { updateProduct, UpdateProductRequestDto } from "#modules/products/infra/updateProduct.api";

type Options = {
  onSuccess?: () => void;
};

export const useUpdateProduct = (options?: Options) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateProductRequestDto }) =>
      updateProduct({ id, payload }),
    onSuccess: () => {
      void queryClient.invalidateQueries(productsQuery());
      options?.onSuccess?.();
    },
    onError: (error: Error) => {
      errorHandler(error);
      showErrorToast({
        title: "Une erreur est survenue",
        message: error.message,
      });
    },
  });

  return { updateProduct: mutate, ...rest };
};
